export default {
    "company_header": "公司详细信息",
    "header_product_warning": "是否注册了合适的 GrabCAD 产品？注册 {0}",
    "label": {
        "first_name": "名",
        "last_name": "姓",
        "name": "姓名",
        "company_name": "公司名称",
        "university_name": "学校名称",
        "role": "职位",
        "company_size": "公司规模",
        "phone_number": "电话号码",
        "printer": "您是否有三维打印机？",
        "student_printer": "您的学校是否有三维打印机？",
        "uses_printer_for": "您使用三维打印机的用途是什么？",
        "shop_owner": "您是否自行管理您的模型商店？",
        "shop_users_expected": "有多少用户在您的商店中提交订单？",
        "email": "电子邮件地址",
        "email_confirm": "确认电子邮件地址",
        "email_again": "重新输入电子邮件地址",
        "password": "密码",
        "country": "位置",
				"state": "国家/地区",
        "password_confirm": "确认密码",
        "password_again": "重新输入密码",
        "password_hint": "最少 6 个字符",
        "interested_in": "我更感兴趣...",
        "industry_vertical": "行业类别",
        "industry_level": "职位等级",
        "business_email": "企业电子邮件地址",
        "business_email_confirm": "确认企业电子邮件地址",
        "recaptcha": "验证您不是机器人",
        "industry_level_select": "选择职位等级",
        "company_size_select": "选择规模",
        "industry_vertical_select": "选择行业类别"
    },
    "placeholders": {
        "name": "例如 John Smith",
        "first": "第一个",
        "last": "第二个",
        "email": "输入电子邮件地址",
        "email_confirm": "重新输入电子邮件地址",
        "password": "输入密码",
        "company_name": "输入公司名称",
        "university_name": "输入学校名称",
        "phone_number": "输入电话号码",
        "printer": "选择回复",
        "country": "选择国家/地区",
				"state": "选择您的国家或地区",
        "business_email": "输入企业电子邮件地址",
        "business_email_confirm": "确认企业电子邮件地址"
    },
    "terms": {
        "buy_now_text": "单击“下一步”即表示您确认已经阅读我们的",
        "workbench_text": "单击“注册 Workbench”即表示您确认已经阅读我们的",
        "print_text": "单击“注册”即表示您确认已经阅读我们的",
        "text": "单击“注册 Community”即表示您确认已经阅读我们的",
        "link": "服务条款"
    },
	"software_terms": {
		"link": "软件条款"
	},
    "privacy_policy": {
        "and": "和",
        "link": "隐私政策",
        "text": "并且您接受并同意受其约束。"
    },
    "actions": {
        "next": "下一步",
        "workbench_sign_up": "注册 Workbench",
        "sign_up_button": "注册",
        "shop_sign_up": "申请免费试用 GrabCAD Shop",
        "sign_up": "注册 Community",
        "cancel": "取消"
    },
    "error": {
        "name_empty": "请添加您的姓名",
        "email_taken": "此电子邮件地址已经注册。请登录或选择其他电子邮件地址。",
        "email_empty": "请添加您的电子邮件地址",
        "email_nomatch": "电子邮件地址必须匹配",
        "email_look": "请输入有效的电子邮件地址",
        "password_nomatch": "密码必须匹配",
        "password_short": "密码太短。长度至少为 6 个字符。",
        "password_empty": "请输入密码",
        "recaptcha": "单击复选框以验证您不是机器人",
        "country_blocked": "抱歉，您不能注册 GrabCAD",
        "blank": "不能为空"
    },
    "active": {
        "email": "请输入您真实的电子邮件地址，我们将发送帐户确认链接至该地址。"
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "否，我不打算",
            "no_but_interesed": "否，但是我感兴趣",
            "yes_for_work": "是，为了工作",
            "yes_as_hobby": "是，只是作为爱好",
            "yes_for_other": "是，因为其他原因"
        },
        "student": {
            "no_dont_plan": "否，我的学校对三维打印不感兴趣",
            "no_but_interesed": "否，但我的学校正在选购三维打印机",
            "yes_they_do": "是",
            "not_sure": "不确定"
        }
    },
    "uses_printer_for": {
        "professional": "专业用途",
        "education": "教育/研究",
        "hobby": "爱好",
        "dont_use": "我不使用三维打印机"
    },
    "level_values": {
        "administrator_principal_superintendent": "管理者/校长/负责人",
        "biomedical_engineer": "生物医学",
        "c_level_executive": "C 级主管",
        "clinical_preclinical": "临床/临床前",
        "dean_department_head": "院长/部门",
        "dentist": "牙医",
        "designer": "设计师",
        "educator": "教育工作者",
        "engineer": "工程师",
        "equipment_manufacturer": "设备制造商",
        "lab_owner": "实验室负责人",
        "lab_technician": "实验室技术人员",
        "marketing": "营销人员",
        "medical_education_and_training": "医学教育和培训人员",
        "parent": "父母",
        "practicing_physician": "执业医师",
        "president_provost": "校长/院长",
        "prosthetist_orthotist": "修复师/矫正器修配者",
        "purchasing": "采购人员",
        "quality": "品质监控人员",
        "rd_engineering": "研发人员/工程师",
        "sales": "销售人员",
        "senior_management_administration": "高级管理/管理人员",
        "student": "学生",
        "training": "培训人员",
        "other": "其他",
        "not_employed": "待业"
    },
    "industry_values": {
        "aerospace": "航空航天",
        "architecture": "建筑",
        "arts_entertainment": "艺术和娱乐",
        "automotive": "汽车",
        "commercial_products": "商业产品",
        "consumer_electronics": "消费性电子产品",
        "consumer_goods": "消费品",
        "dental": "牙科产品",
        "education": "教育",
        "engineering_consulting_service": "工程咨询服务",
        "government_military": "政府/军队",
        "industrial_equipment": "工业设备",
        "jewelry": "珠宝",
        "medical_device": "医疗仪器或设备",
        "service_bureau": "服务局",
        "toys": "玩具",
        "reseller": "转销商",
        "other": "其他"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "不是公司"
    },
    "yes_no_values": {
        "yes": "是",
        "no": "否"
    }
}
